import React, { useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';

export interface ITableCardProps {
    children: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
}

export default function TableCard({
    children,
    style,
    className,
}: ITableCardProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    return (
        <div
            className={className}
            style={{
                background: isDark ? '#141414' : '#ffffff',
                borderRadius: 14,
                border: `1px solid ${isDark ? '#262626' : '#eaedf1'}`,
                boxShadow: isDark
                    ? '0 4px 20px rgba(0, 0, 0, 0.35)'
                    : '0 2px 12px rgba(0, 0, 0, 0.04)',
                overflow: 'hidden',
                ...style,
            }}
        >
            {children}
        </div>
    );
}
